import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import { getRecentlySearch } from '../_util';
import { mergeModules } from '@/store/helpers';
import common from '../../md-search/_store/common';
// import { searchCenter } from './isSearchCenter';
function initState({ searchCenter }) {
    const common = {
        outsideFields: [],
        conditions: {},
        keywords: [],
        recentlySearch: getRecentlySearch(),
        mapCondition: {},
        customizedCity: [],
        searchCharts: [],
        listingIds: '',
        currencyPriceKeys: [] // 存放搜索配置里面与price有关的字段，需要转成美元, 搜索的时候传美元
    };
    const state = {
        // fetcherData moduleMap conditionSort 数据冗余
        fetcherData: {}, // 渲染用的数据，包含分组等信息
        moduleMap: {}, // 保留 condition 的配置项，方便读取
        conditionSort: [], // 用于tag的排序
        searchQueryOnUrl: null,
        hasConditionOnUrl: false,
        locationQueryOnUrl: '',
        urlPresetParams: null,
        mapConditionOnUrl: {
            rect: '',
            mapPath: '',
            mapSearch: false,
            zoom: 14,
            threshold: 10
        }
        // ...common
    };
    const centerState = {
        uiConfig: {},
        // outsideFields: [],
        searchConfigMap: {},
        computedPresetFilter: {},
        urlPresetParams: null,
        conditionOnUrl: {}
        // ...common
    };
    return {
        ...common,
        ...(searchCenter ? centerState : state)
    };
}

const modules = mergeModules(common, {
    namespaced: true,
    state: initState,
    getters,
    mutations,
    actions
});
export default modules;
